<template>
  <Layout>
    <div v-if="sfrMode" style="display: flex; justify-content: center" class="sfr-logo">
      <img style="width: 350px" src="@/assets/img/logo3-sfr.png"/>
    </div>
    <div class="login-form">
      <h1>MANAGER</h1>
      <form class="form" @submit.prevent="onFormSubmit">
        <div class="messages">
          <div class="message error" :class="{show:showMessage}">
            <font-awesome-icon icon="times" @click="closeMessage()"/>
            <font-awesome-icon icon="exclamation-circle" class="indicator"/>
            <div class="message-inner">
              <span>{{ errorMessage }}</span>
            </div>
          </div>
        </div>
        <div class="form-row row">
          <font-awesome-icon icon="user"/>
          <input id="username" name="username" class="form-input col" type="text" v-model.lazy="user.login"
                 :placeholder="placeholders.login"/>
        </div>
        <div class="form-row row">
          <font-awesome-icon icon="lock"/>
          <input id="password" name="password" class="form-input col" type="password"
                 v-model.lazy="user.password"
                 :placeholder="placeholders.password"/>
        </div>
        <Btn :class="'default block'" :btnType="'submit'" @click.native.prevent="onFormSubmit">
          {{ $t('login.loginBtn') }}
        </Btn>
        <div class="login-separator">
          <hr>
          <span>OU</span>
        </div>
        <Btn :class="'google block'" :btnType="'button'" @click.native.prevent="onGoogleLogin">
          <GoogleIcon></GoogleIcon>
          {{ $t('login.googleLoginBtn') }}
        </Btn>
        <input v-show="false" type="submit"/>
        <div v-if="false" class="center password-lost">
          <Btn :class="[{'force-hover':passwordLostShow},'mini']" @click.native.prevent="onPasswordLost">
            {{ $t('login.passwordLost') }}
          </Btn>
          <div class="password-lost-popover" :class="{show:passwordLostShow}">
            <i class="fa fa-times" @click.prevent="closePasswordLost"></i>
            <p>{{ $t('login.explainPasswordLost') }}</p>
            <div class="form-row row">
              <div class="col">
                <i class="fa fa-envelope"></i>
                <input type="email" class="form-input" v-model="emailLostPassword"
                       :placeholder="placeholders.emailPasswordLost"/>
              </div>
              <div class="col-2">
                <Btn :class="'icon pull-right'" @click.native="requestPasswordLost"><i
                    class="fa fa-arrow-circle-right"></i></Btn>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div ref="httpcsBadge" class="httpcs-badge"></div>
  </Layout>
</template>

<script>

import Vue from 'vue'
import Layout from '@l/Blank'
import src from '@/assets/img/logo2.svg'
import srcSFR from '@/assets/img/logo2-sfr.svg'
import Btn from '@c/ui/Button'
import {mapGetters, mapMutations, mapActions} from 'vuex'


export default {
  name: 'login',
  components: {
    Layout,
    Btn
  },
  computed: {
    ...mapGetters({
      can: 'Auth/can'
    }),
    logo() {
      return srcSFR
    },
    sfrMode() {
      const locationHost = window.location.host

      if (locationHost.includes('sfr') && locationHost.includes('beepiz')) {
        return true
      }

      return false
    },
    beepizMode() {
      const locationHost = window.location.host

      if (!locationHost.includes('sfr') && locationHost.includes('beepiz')) {
        return true
      }

      return false
    },
  },
  data: () => ({
    user: {
      login: '',
      password: ''
    },
    placeholders: {
      login: window.V.$i18n.t('login.login'),
      password: window.V.$i18n.t('login.password'),
      emailPasswordLost: window.V.$i18n.t('login.emailPasswordLost')
    },
    errorMessage: '',
    showMessage: false,
    emailLostPassword: '',
    passwordLostShow: false,
    //logo: src
  }),

  methods: {
    ...mapMutations({
      showLoading: 'UI/showLoading',
      loadingProgress: 'UI/loadingProgress',
      addError: 'Messages/addError'
    }),

    ...mapActions({
      login: 'Auth/login',
      googleLogin: 'Auth/googleLogin',
      logout: 'Auth/logout',
      fetchUser: 'Auth/fetchUser',
      fetchPermissions: 'Auth/fetchPermissions',
      getClientInfos: 'Papers/getClientInfos',

    }),

    onFormSubmit: function (evt) {
      var vThis = this;
      if (this.user.login != "" && this.user.password != "") {
        this.showLoading(true);
        this.loadingProgress(1);
        this.login({username: this.user.login, password: this.user.password})
            .then(response => {
              this.afterLogin()
            })
            .catch(e => {
              if (window.loginError != '' && window.loginError != null) {
                this.errorMessage = window.loginError;
                this.showMessage = true;
              } else {
                this.errorMessage = '';
                this.showMessage = false;
              }
              this.showLoading(false);
            })
      } else {
        vThis.errorMessage = 'Les champs identifiant ou Mot de passe doivent être remplis';
        /*Utils.t('login.emptyLoginPassword');*/
        vThis.showMessage = true;
      }
    },
    afterLogin() {
      this.loadingProgress(25);
      this.fetchUser()
          .then(response => {
            this.loadingProgress(50);
            this.fetchPermissions()
                .then(response => {
                  if (this.can('global-access-admin')) {
                    this.loadingProgress(75);
                    this.getClientInfos()
                        .then(responseClientInfos => {
                          this.loadingProgress(100);
                          var redirect = '/users';
                          if (!this.can('admin-browse-users')) {
                            if (this.can('admin-bills-client')) {
                              redirect = '/client/bills'
                            }
                          }
                          if (window.V._router.app._route.query.redirect) {
                            if (window.V._router.app._route.query.redirect != '/logout') {
                              redirect = window.V._router.app._route.query.redirect;
                            }

                          }

                          this.errorMessage = '';
                          this.showMessage = false;
                          window.V._router.push(redirect);
                        })
                  } else {
                    this.addError('Vous n\'avez pas la permission nécessaire pour vous connecter')
                    this.logout();

                    window.V._router.push('/login');
                    this.showLoading(false);
                  }

                })
                .catch(e => {
                  //TODO A gérer
                })

          })
          .catch(e => {
            console.error(e);
            //TODO A gérer
          })
    },
    closeMessage: function (type) {
      this.showMessage = false;
    },
    onPasswordLost: function (evt) {
      this.passwordLostShow = !this.passwordLostShow;
    },
    closePasswordLost: function (evt) {
      this.passwordLostShow = false;
    },
    onGoogleLogin() {
      Vue.googleAuth().directAccess()
      Vue.googleAuth().signIn(googleUser => {
        this.showLoading(true);
        this.loadingProgress(1);
        let accessToken = googleUser.Sc.access_token
        this.googleLogin(accessToken)
            .then(response => {
              this.afterLogin()
            })
            .catch(e => {
              if (window.loginError != '' && window.loginError != null) {
                this.errorMessage = window.loginError;
                this.showMessage = true;
              } else {
                this.errorMessage = '';
                this.showMessage = false;
              }
              this.showLoading(false);
            })
      }, function (error) {
        console.log(error)
      })
    }
  },
  mounted() {
    window.V.loginMode = true;
    var userLang = navigator.language || navigator.userLanguage;
    if (this.$route.params.token == null) {
      //window.Vfc.$refs.loading.hide();
      this.showLoading(false);
    }
    let script = document.createElement('script');
    script.setAttribute('type', "text/javascript");
    script.setAttribute('src', "https://www.httpcs.com/certified/js/59084/client.suivideflotte.net");
    script.setAttribute('async', true);
    script.setAttribute('defer', true);
    this.$refs.httpcsBadge.appendChild(script);
  },
  updated() {
    if (this.$route.params.token == null) {
      //window.Vfc.$refs.loading.hide();
      //this.showLoading(false);
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (window.loginError != '' && window.loginError != null) {
      this.errorMessage = window.loginError;
      this.showMessage = true;
    } else {
      this.errorMessage = '';
      this.showMessage = false;
    }
    next();
  },
}
</script>

<style lang="scss">
.login-form {
  background-color: $main-color;
  left: 50%;
  position: fixed;
  top: 50%;
  transform: translate(-50%, -50%);
  box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.35);

  h1 {
    color: $main-color;
    left: 0;
    position: absolute;
    width: 100%;
    text-align: center;
    user-select: none;
  }

  .form-row {
    position: relative;

    .svg-inline--fa:not(.fa-arrow-circle-right) {
      color: lighten($main-black, 10%);
      font-size: 1.3rem;
      line-height: $form-elements-line-height;
      position: absolute;
      text-align: center;
      top: 8px;
      width: $form-elements-line-height;
      z-index: 1;
    }

    .form-input {
      border: none;
      padding-left: $form-elements-line-height;
    }
  }

  .button.default {
    background-color: $main-black;
    color: $main-white;
    font-weight: $bold;

    &:before, &:after, .button-inner:before, .button-inner:after {
      background-color: $main-white;
    }

    &:hover {
      background-color: $main-white;
      color: $main-black;
    }
  }

  .password-lost {
    bottom: -100px;
    left: 0;
    position: absolute;
    width: 100%;

    .password-lost-popover {
      background-color: $main-white;
      bottom: 45px;
      left: 50%;
      margin-left: -200px;
      opacity: 0;
      padding: 10px;
      pointer-events: none;
      position: absolute;
      text-align: left;
      transform: translate(0, 20px);
      transition-property: opacity, transform;
      width: 400px;
      z-index: 100;
      box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.35);

      &:after {
        border-color: #ffffff transparent transparent transparent;
        border-style: solid;
        border-width: 12.1px 7px 0 7px;
        content: '';
        height: 0;
        left: 193px;
        position: absolute;
        bottom: -10px;
        width: 0;
      }

      .fa-times {
        cursor: pointer;
        display: inline-block;
        height: $button-height;
        line-height: $button-height;
        position: absolute;
        right: 0;
        text-align: center;
        top: 0;
        width: $button-height;
        z-index: 2;
      }

      &.show {
        pointer-events: auto;
        opacity: 1;
        transform: translate(0, 0);
      }

      p {
        padding: 10px 10px 15px;
        text-align: justify;
      }

      * {
        color: $main-black !important;
      }

      .fa-envelope {
        font-size: 1.7rem;
      }

      .col, .col-2 {
        padding: 0;
      }

      .form-row {
        padding: 0 10px;
      }

      .form-input {
        border: solid $main-black 3px;
        width: 100%;
      }

      .button {
        font-size: 1.6rem;

        &:before, &:after, .button-inner:before, .button-inner:after {
          background-color: $main-black;
        }
      }
    }
  }

  .messages {
    margin: 0;
    top: -70px;
    left: -40px;
    right: -40px;
  }

}

.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  color: $main-white;
  text-align: center;
  line-height: 30px;

  a {
    color: $main-color;
  }
}

.login-separator {
  position: relative;

  hr {
    border-color: $main-white;
    margin: 20px 0;
  }

  span {
    background-color: $main-color;
    color: $main-white;
    padding: 0 5px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

.sfr {
  .sfr-logo {
    margin-top: 250px;
  }

  .login-form {
    background-color: $sfr-color !important;
    left: 50%;
    position: fixed;
    top: 65%;
    transform: translate(-50%, -50%);
    box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.35);

    h1 {
      color: $sfr-color;
      left: 0;
      position: absolute;
      width: 100%;
      text-align: center;
      user-select: none;
    }

    .form-row {
      position: relative;

      .svg-inline--fa:not(.fa-arrow-circle-right) {
        color: lighten($main-black, 10%);
        font-size: 1.3rem;
        line-height: $form-elements-line-height;
        position: absolute;
        text-align: center;
        top: 8px;
        width: $form-elements-line-height;
        z-index: 1;
      }

      .form-input {
        border: none;
        padding-left: $form-elements-line-height;
      }
    }

    .button.default {
      background-color: $main-black;
      color: $main-white;
      font-weight: $bold;

      &:before, &:after, .button-inner:before, .button-inner:after {
        background-color: $main-white;
      }

      &:hover {
        background-color: $main-white;
        color: $main-black;
      }
    }

    .password-lost {
      bottom: -100px;
      left: 0;
      position: absolute;
      width: 100%;

      .password-lost-popover {
        background-color: $main-white;
        bottom: 45px;
        left: 50%;
        margin-left: -200px;
        opacity: 0;
        padding: 10px;
        pointer-events: none;
        position: absolute;
        text-align: left;
        transform: translate(0, 20px);
        transition-property: opacity, transform;
        width: 400px;
        z-index: 100;
        box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.35);

        &:after {
          border-color: #ffffff transparent transparent transparent;
          border-style: solid;
          border-width: 12.1px 7px 0 7px;
          content: '';
          height: 0;
          left: 193px;
          position: absolute;
          bottom: -10px;
          width: 0;
        }

        .fa-times {
          cursor: pointer;
          display: inline-block;
          height: $button-height;
          line-height: $button-height;
          position: absolute;
          right: 0;
          text-align: center;
          top: 0;
          width: $button-height;
          z-index: 2;
        }

        &.show {
          pointer-events: auto;
          opacity: 1;
          transform: translate(0, 0);
        }

        p {
          padding: 10px 10px 15px;
          text-align: justify;
        }

        * {
          color: $main-black !important;
        }

        .fa-envelope {
          font-size: 1.7rem;
        }

        .col, .col-2 {
          padding: 0;
        }

        .form-row {
          padding: 0 10px;
        }

        .form-input {
          border: solid $main-black 3px;
          width: 100%;
        }

        .button {
          font-size: 1.6rem;

          &:before, &:after, .button-inner:before, .button-inner:after {
            background-color: $main-black;
          }
        }
      }
    }

    .messages {
      margin: 0;
      top: -70px;
      left: -40px;
      right: -40px;
    }

  }

  .login-separator {
    position: relative;

    hr {
      border-color: $main-white;
      margin: 20px 0;
    }

    span {
      background-color: $sfr-color;
      color: $main-white;
      padding: 0 5px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
}

.beepiz {
  .sfr-logo {
    margin-top: 250px;
  }

  .login-form {
    background-color: $beepiz-color !important;
    left: 50%;
    position: fixed;
    top: 65%;
    transform: translate(-50%, -50%);
    box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.35);

    h1 {
      color: $beepiz-color;
      left: 0;
      position: absolute;
      width: 100%;
      text-align: center;
      user-select: none;
    }

    .form-row {
      position: relative;

      .svg-inline--fa:not(.fa-arrow-circle-right) {
        color: lighten($main-black, 10%);
        font-size: 1.3rem;
        line-height: $form-elements-line-height;
        position: absolute;
        text-align: center;
        top: 8px;
        width: $form-elements-line-height;
        z-index: 1;
      }

      .form-input {
        border: none;
        padding-left: $form-elements-line-height;
      }
    }

    .button.default {
      background-color: $main-black;
      color: $main-white;
      font-weight: $bold;

      &:before, &:after, .button-inner:before, .button-inner:after {
        background-color: $main-white;
      }

      &:hover {
        background-color: $main-white;
        color: $main-black;
      }
    }

    .password-lost {
      bottom: -100px;
      left: 0;
      position: absolute;
      width: 100%;

      .password-lost-popover {
        background-color: $main-white;
        bottom: 45px;
        left: 50%;
        margin-left: -200px;
        opacity: 0;
        padding: 10px;
        pointer-events: none;
        position: absolute;
        text-align: left;
        transform: translate(0, 20px);
        transition-property: opacity, transform;
        width: 400px;
        z-index: 100;
        box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.35);

        &:after {
          border-color: #ffffff transparent transparent transparent;
          border-style: solid;
          border-width: 12.1px 7px 0 7px;
          content: '';
          height: 0;
          left: 193px;
          position: absolute;
          bottom: -10px;
          width: 0;
        }

        .fa-times {
          cursor: pointer;
          display: inline-block;
          height: $button-height;
          line-height: $button-height;
          position: absolute;
          right: 0;
          text-align: center;
          top: 0;
          width: $button-height;
          z-index: 2;
        }

        &.show {
          pointer-events: auto;
          opacity: 1;
          transform: translate(0, 0);
        }

        p {
          padding: 10px 10px 15px;
          text-align: justify;
        }

        * {
          color: $main-black !important;
        }

        .fa-envelope {
          font-size: 1.7rem;
        }

        .col, .col-2 {
          padding: 0;
        }

        .form-row {
          padding: 0 10px;
        }

        .form-input {
          border: solid $main-black 3px;
          width: 100%;
        }

        .button {
          font-size: 1.6rem;

          &:before, &:after, .button-inner:before, .button-inner:after {
            background-color: $main-black;
          }
        }
      }
    }

    .messages {
      margin: 0;
      top: -70px;
      left: -40px;
      right: -40px;
    }

  }

  .login-separator {
    position: relative;

    hr {
      border-color: $main-white;
      margin: 20px 0;
    }

    span {
      background-color: $beepiz-color;
      color: $main-white;
      padding: 0 5px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Login.vue